import { render, staticRenderFns } from "./Call.vue?vue&type=template&id=241d2a2e&scoped=true"
import script from "./Call.vue?vue&type=script&lang=js"
export * from "./Call.vue?vue&type=script&lang=js"
import style0 from "./Call.vue?vue&type=style&index=0&id=241d2a2e&prod&lang=scss"
import style1 from "./Call.vue?vue&type=style&index=1&id=241d2a2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241d2a2e",
  null
  
)

export default component.exports